module.exports = __webpack_public_path__ + "img/loveprint.3db7c689.png";